__turbopack_context__.v({
  "AirtableForm": "AirtableForm-module-scss-module__Jgc27G__AirtableForm",
  "Loader": "AirtableForm-module-scss-module__Jgc27G__Loader",
});
